/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Admin_DescriptionInputs */

const es_walkthrough_admin_description = /** @type {(inputs: Walkthrough_Admin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como admin, podés gestionar usuarios, facturación, planes y monitorear la actividad del sistema desde el panel de administrador.`)
};

const en_walkthrough_admin_description = /** @type {(inputs: Walkthrough_Admin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As an admin, you can manage users, billing, plans, and monitor system activity from the admin panel.`)
};

/**
* | output |
* | --- |
* | "As an admin, you can manage users, billing, plans, and monitor system activity from the admin panel." |
*
* @param {Walkthrough_Admin_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_admin_description = /** @type {((inputs?: Walkthrough_Admin_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Admin_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_admin_description(inputs)
	return en_walkthrough_admin_description(inputs)
});
export { walkthrough_admin_description as "walkthrough.admin_description" }